import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { TheProblem } from '../components/TheProblem';
import { WhyItDidntWork } from '../components/WhyItDidntWork';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-dark-navy text-stone-200 font-sans" data-id="element-165">
      <Hero data-id="element-166" />
      <OpeningHook data-id="element-167" />
      <TheProblem data-id="element-168" />
      <WhyItDidntWork data-id="element-169" />
      <UniqueMechanism data-id="element-170" />
      <WhatYouGet data-id="element-171" />
      <WhoThisIsFor data-id="element-172" />
      <HowItWorks data-id="element-173" />
      <Proof data-id="element-174" />
      <Testimonials data-id="element-175" />
      <FAQ data-id="element-176" />
      <FinalOffer data-id="element-177" />
      <Footer data-id="element-178" />
    </div>;
}